<template>
  <div>
    <!-- FILTER -->
    <b-card
      no-body
    >
      <b-card-body>
        <b-row class="justify-content-between">
          <b-col
            cols="12"
            md="3"
            class="mb-md-0 mb-2"
          >
            <h6>Menampilkan laporan produk</h6>
            <h4>
              {{
                selectedFilter.startMonth !== selectedFilter.endMonth
                  || selectedFilter.startYear !== selectedFilter.endYear
                  ? selectedFilter.startMonth : ''
              }}
              {{
                selectedFilter.startYear !== selectedFilter.endYear
                  ? selectedFilter.startYear : ''
              }}
              {{
                selectedFilter.startMonth !== selectedFilter.endMonth
                  || selectedFilter.startYear !== selectedFilter.endYear
                  ? '-' : ''
              }}
              {{ selectedFilter.endMonth }}
              {{ selectedFilter.endYear }}
            </h4>
          </b-col>
          <b-col
            cols="12"
            md="9"
            class="mb-md-0 mb-2"
          >
            <b-row>
              <b-col
                cols="12"
              >
                <FilterForm
                  :data="filter"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <!-- <b-row
          v-if="!isPending && !reportMounthly.length"
          align-v="center"
          class="mt-3"
        >
          <b-col>
            <b-alert
              show
              variant="warning"
            >
              <div class="alert-body">
                <feather-icon
                  class="mr-25"
                  icon="AlertCircleIcon"
                />
                <span class="ml-25">Data tidak ditemukan</span>
              </div>
            </b-alert>
          </b-col>
        </b-row> -->
      </b-card-body>
    </b-card>
    <!-- NOTE product section -->
    <b-row class="match-height">
      <b-col
        cols="12"
        md="3"
      >
        <b-card
          class="card-tiny-line-stats"
        >
          <h6 class="mb-2">
            Total Produk
          </h6>
          <b-media no-body>
            <b-media-aside
              class="mr-1"
            >
              <b-avatar
                size="36"
                variant="light-primary"
              >
                <feather-icon
                  size="20"
                  icon="BoxIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <div v-if="!loadingProductGrowth">
                <h1 class="font-weight-bolder mb-0">
                  {{ toThousands(productGrowth.statistic[0] ? productGrowth.statistic[productGrowth.statistic.length - 1].z : 0) }}
                </h1>
                <b-card-text class="font-small-3 mb-0">
                  produk
                </b-card-text>
              </div>
              <div v-else>
                <b-skeleton
                  animation="wave"
                  width="50%"
                />
                <b-skeleton
                  animation="wave"
                  width="25%"
                />
              </div>
            </b-media-body>
          </b-media>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="9"
      >
        <b-overlay
          :show="loadingProductGrowth"
          rounded="sm"
        >
          <ProductGrowthChart
            :chart-data="productGrowth.statistic"
          />
        </b-overlay>
      </b-col>
    </b-row>
    <!-- NOTE sku section -->
    <b-row class="match-height">
      <b-col
        cols="12"
        md="3"
      >
        <b-card
          class="card-tiny-line-stats"
        >
          <h6 class="mb-2">
            Total SKU
          </h6>
          <b-media no-body>
            <b-media-aside
              class="mr-1"
            >
              <b-avatar
                size="36"
                variant="light-info"
              >
                <feather-icon
                  size="20"
                  icon="InboxIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <div v-if="!loadingSkuGrowth">
                <h1 class="font-weight-bolder mb-0">
                  {{ toThousands(skuGrowth.statistic[0] ? skuGrowth.statistic[skuGrowth.statistic.length - 1].z : 0) }}
                </h1>
                <b-card-text class="font-small-3 mb-0">
                  SKU
                </b-card-text>
              </div>
              <div v-else>
                <b-skeleton
                  animation="wave"
                  width="50%"
                />
                <b-skeleton
                  animation="wave"
                  width="25%"
                />
              </div>
            </b-media-body>
          </b-media>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="9"
      >
        <b-overlay
          :show="loadingSkuGrowth"
          rounded="sm"
        >
          <SkuGrowthChart
            :chart-data="skuGrowth.statistic"
          />
        </b-overlay>
      </b-col>
    </b-row>
    <!-- NOTE algolia section -->
    <b-row class="match-height">
      <b-col
        cols="12"
        md="4"
      >
        <CardEmptyResultSearch
          :data="emptyResultSearch"
          :loading="loadingEmptyResultsSearch"
        />
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <CardTopResult
          title="Top Result"
          :data="topResult"
          :loading="loadingEmptyResultsSearch"
        />
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <CardTopSearches
          title="Top Search"
          :data="topSearch"
          :loading="loadingEmptyResultsSearch"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ProductGrowthChart from '@/layouts/components/chart/ProductGrowthChart.vue'
import SkuGrowthChart from '@/layouts/components/chart/SkuGrowthChart.vue'

import {
  BMedia,
  BMediaAside,
  BMediaBody,
  BAvatar,
  BCard,
  BCardBody,
  BCardText,
  BRow,
  BCol,
  BOverlay,
  BSkeleton,
} from 'bootstrap-vue'
import CardEmptyResultSearch from './CardEmptyResultSearch.vue'
import CardTopSearches from './CardTopSearches.vue'
import CardTopResult from './CardTopResult.vue'
import FilterForm from './FilterForm.vue'

export default {
  components: {
    ProductGrowthChart,
    SkuGrowthChart,
    FilterForm,
    BAvatar,
    BCard,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BRow,
    BCol,
    BCardBody,
    CardEmptyResultSearch,
    CardTopSearches,
    CardTopResult,
    BOverlay,
    BSkeleton,
  },
  data() {
    const now = new Date()
    return {
      isLoading: false,
      filter: {
        startMonth: now.getMonth() - 1,
        endMonth: now.getMonth() + 1,
        startYear: now.getFullYear(),
        endYear: now.getFullYear(),
      },
      loadingProductGrowth: false,
      loadingSkuGrowth: false,
      loadingEmptyResultsSearch: false,
      loadingTopSearch: false,
      loadingTopResult: false,
    }
  },
  computed: {
    ...mapState('products', [
      'productGrowth',
      'skuGrowth',
      'emptyResultSearch',
      'topSearch',
      'topResult',
    ]),
    ...mapState('dashboard', ['monthsOptions']),
    selectedFilter() {
      return {
        startMonth: this.monthsOptions.find(el => el.value === this.filter.startMonth).label,
        endMonth: this.monthsOptions.find(el => el.value === this.filter.endMonth).label,
        startYear: this.filter.startYear,
        endYear: this.filter.endYear,
      }
    },
  },
  watch: {
    filter: {
      handler(val) {
        this.loadData(val)
      },
      deep: true,
    },
  },
  created() {
    this.loadData(this.filter)
  },
  methods: {
    ...mapActions('products', [
      'getProductGrowth',
      'getSkuGrowth',
      'getEmptyResultsSearch',
      'getTopSearch',
      'getTopResult',
    ]),
    async loadData(val) {
      this.loadProductGrowth(val)
      this.loadSkuGrowth(val)
      this.loadEmptyResultsSearch(val)
      this.loadTopSearch(val)
      this.loadTopResult(val)
    },
    async loadProductGrowth(val) {
      this.loadingProductGrowth = true
      await this.getProductGrowth(val)
      this.loadingProductGrowth = false
    },
    async loadSkuGrowth(val) {
      this.loadingSkuGrowth = true
      await this.getSkuGrowth(val)
      this.loadingSkuGrowth = false
    },
    async loadEmptyResultsSearch(val) {
      this.loadingEmptyResultsSearch = true
      await this.getEmptyResultsSearch(val)
      this.loadingEmptyResultsSearch = false
    },
    async loadTopSearch(val) {
      this.loadingTopSearch = true
      await this.getTopSearch(val)
      this.loadingTopSearch = false
    },
    async loadTopResult(val) {
      this.loadingTopResult = true
      await this.getTopResult(val)
      this.loadingTopResult = false
    },
  },
}
</script>
